var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticClass:"part-details-table"},_vm._l((_vm.labelValuePairs),function(part){return _c('tr',{key:part.label},[_c('td',{staticClass:"font-weight-bold pr-4"},[_vm._v("\n      "+_vm._s(part.label)+":\n    ")]),_vm._v(" "),_c('td',[_vm._v("\n      "+_vm._s(part.value)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }